// ═══════════════════════════════════════════════════════════════
// FoodCostOS Frontend — bootstrap Vue 3
// ═══════════════════════════════════════════════════════════════
// Ordre important :
//   1. Pinia créé AVANT d'utiliser n'importe quel store
//   2. `attachAuthStore` branche le store auth sur axios (refresh auto)
//   3. Le router consomme déjà le store auth dans son guard
//   4. App.vue déclenche `auth.bootstrap()` au onMounted
// ═══════════════════════════════════════════════════════════════

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { queryClient } from './lib/query-client.js';
import App from './App.vue';
import router from './router';
import { i18n } from './lib/i18n.js';
import { attachAuthStore } from './lib/api.js';
import { useAuthStore } from './stores/auth.js';
import { applyBrandAssets } from './lib/brand.js';
import './assets/main.css';

// Applique le favicon + titre + couleurs CSS selon le hostname (brand)
applyBrandAssets();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, { queryClient });

// Donne à l'instance axios une référence au store auth (briser la dépendance circulaire)
attachAuthStore(() => useAuthStore());

app.mount('#app');
